import React, { useEffect, useState, useRef } from "react";
import styles from "../restaurant/mobilerestaurantstatus.module.css";
import { ReactComponent as Trash } from "../../../src/svg/trash-can-regular.svg";
import { ReactComponent as CircleDollar } from "../../../src/svg/wallet-outline.svg";
import { ReactComponent as Ticket } from "../../../src/svg/ticket-regular.svg";

import { returnDayString } from "../etc/functions";

import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

import { useIonActionSheet } from '@ionic/react';
import { Skeleton } from "@mui/material";
import { getFetch, postFetch } from "../../fetch/fetch";
import { addZeroIfOne } from "../../dashboard/components/controls/etc/etcfunctions";
import { dontNeedSunbaePayAcademies } from "../data/datas";



const MobileContentStatus: React.FC<any> = (props) => {


    const [loading, setLoading] = useState(false);
    const topRef = useRef<any>(null);

    const [today, setToday] = useState(new Date());
    const [checkResult, setCheckResult] = useState([]);
    const [descriptionHeight, setDescriptionHeight] = useState(0);

    const [update, setUpdate] = useState(0);

    const [present] = useIonActionSheet();


    useEffect(() => {


        if (!topRef || !topRef.current || !props.statusDivHeight) {
            return;
        }

        const caculateBodyHeight = () => {



            if (!topRef || !topRef.current || !props.statusDivHeight) {
                return;
            }

            const totalHeight = props.statusDivHeight;
            const topHeight = topRef.current.offsetHeight;

            const descriptionHeight = totalHeight - topHeight - (1.9 * 16);





            setDescriptionHeight(descriptionHeight);
        }

        caculateBodyHeight();

        window.addEventListener("resize", caculateBodyHeight);

        return () => window.removeEventListener("resize", caculateBodyHeight);


    }, [topRef, props.statusDivHeight]);



    useEffect(() => {

        setLoading(true);

        const start = async () => {

            try{

                const result : any = await getFetch("/dashboard/payments/content/checkMobileForContents");

                if(result.message === "success"){
                    setCheckResult(result.totalData);
                    setLoading(false);
                }

            }catch(e){
                setLoading(false);
                console.log(e)
            }

        }

        start();

    }, [update]);


    const confirmDelete = (id: number) => {
        
        present({
            header: "컨텐츠 결제 신청 취소",
            subHeader: "컨텐츠 결제 신청을 취소할까요?",
            buttons: [{
                text: "취소",
                role: "destructive"
            },
            {
                role: "cancel",
                text: "아니오",
            }
            ],
            onDidDismiss: ({ detail }) => {

                switch (detail.role) {
                    case "destructive":
                        deleteContents(id);
                        break;
                    case "cancel":
                        break;
                }
            },
        })
    }


    const deleteContents = async (id: number) => {

        if (!id) {
            alert("id가 없습니다");
            return;
        }

        setLoading(true);

        try{

            const result : any = await postFetch("/dashboard/payments/buycontent/delete", {
                id
            });

            if(result.message === "success"){
                props.handleToastMessage2("🗑️ 컨텐츠 결제 신청 취소가 정상 처리되었습니다");
                setUpdate(Math.random());
                props.letsUpdate();
            }

            if(result.message === "TIME_OUT"){
                props.handleToastMessage("🥵 취소 시간이 지났습니다");
                setLoading(false);
            }

        }catch(e){
            setLoading(false);
            console.log(e);
        }
    }

    return (
        <div className={styles.statusBody} style={{
            paddingTop : "0px",
        }}>
            <div className={styles.statusTop} ref={topRef}>
                <div className={styles.statusTitle}>
                    컨텐츠 신청 현황
                </div>
                <div className={styles.statusNumber}>
                    {today.getMonth() + 1}월 {today.getDate()}일 {returnDayString(today.getDay())}요일 기준
                </div>
            </div>

            {
                loading
                &&
                <div style={{ width: "90.6%", margin: "0 auto" }}>
                    <div style={{ height: "20px" }}>
                    </div>
                    <Skeleton variant="rectangular" width="100%" height={140} />
                    <div style={{ height: "20px" }}>
                    </div>
                    <Skeleton variant="rectangular" width="100%" height={140} />
                    <div style={{ height: "20px" }}>
                    </div>
                    <Skeleton variant="rectangular" width="100%" height={140} />
                    <div style={{ height: "20px" }}>
                    </div>
                </div>
            }


            <div className={styles.description} style={{ height: `${descriptionHeight}px`, overflow: "scroll" }}>
                <div className={styles.descriptionBody}>


                    {
                        (checkResult && checkResult.length > 0) &&
                        checkResult.map((eachCheckResult: any, index: number) => {


                            const targetDate = new Date(eachCheckResult.createdAt);

                            var targetDateDay = returnDayString(targetDate.getDay());

                            const targetDateString = `${targetDate.getMonth() + 1}월 ${targetDate.getDate()}일 ${targetDateDay}요일 신청`;

                            const endDate = new Date(eachCheckResult.content.endDateTime);

                            var canDelete = true;

                            const endTime = endDate.getTime();
                            const currentTime = new Date().getTime();

                            if (endTime < currentTime) {
                                canDelete = false;
                            }

                            //endDateString 8월 24일 22:00
                            const endDateString = `${endDate.getMonth() + 1}월 ${endDate.getDate()}일 ${addZeroIfOne(endDate.getHours())}:${addZeroIfOne(endDate.getMinutes())}`;

                            return (
                                <div key={eachCheckResult.id}>
                                    <div className={`${styles.eachDescription} ${checkResult.length - 1 === index ? styles.last : ""}`}>
                                        <div className={styles.eachDescriptionDate}>
                                            {targetDateString}
                                        </div>
                                        <div className={styles.eachDescriptionBox}>
                                            <div className={styles.eachDescriptionText}>
                                                {eachCheckResult.content.menuName.length > 30 ? eachCheckResult.content.menuName.substring(0, 30) + "..." : eachCheckResult.content.menuName}
                                            </div>
                                            <div className={styles.eachDescriptionTargetDate} style={{
                                                lineHeight : 1.5
                                            }}>
                                                구매 갯수 : {eachCheckResult.number}개<br />
                                                구매 상태 : {eachCheckResult.isPaid ? "결제 완료" : "미결제"}<br />
                                            </div>
                                            <div style={{
                                                marginBottom : "0.853rem"
                                            }}>
                                                {
                                                    eachCheckResult.selectedOptions
                                                        ?
                                                        eachCheckResult.selectedOptions.map((eachOption: any, index: number) => {
                                                            return (
                                                                <div key={index} className={styles.eachDescriptionOption}>
                                                                    {eachOption.optionName} : {eachOption.optionItem}
                                                                </div>
                                                            );
                                                        })
                                                        :
                                                        ""
                                                }
                                            </div>
                                            <div className={styles.eachDescriptionKindDiv}>
                                                <div className={styles.eachDescriptionKindText}>
                                                    {eachCheckResult.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                                                </div>
                                            </div>
                                            {
                                                eachCheckResult.price === Math.abs(+eachCheckResult.diff_amount) ?
                                                <div className={styles.trashCanDiv} onClick={(e: any) => { confirmDelete(eachCheckResult.id); }}>
                                                    <Trash fill="#251e1c" className={styles.trash} />
                                                </div>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>

                                </div>
                            );

                        })
                    }

                </div>
            </div>



        </div>
    );
}

export default MobileContentStatus;